import { render } from "./FeatureRow.vue?vue&type=template&id=9ee50eea&scoped=true"
import script from "./FeatureRow.vue?vue&type=script&lang=js"
export * from "./FeatureRow.vue?vue&type=script&lang=js"

import "./FeatureRow.vue?vue&type=style&index=0&id=9ee50eea&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ee50eea"]])

export default __exports__